import { Store } from "pullstate";
import { HistoryMetadataByChain, TradeHistoryData } from "../../types/history";
import { attachReactions } from "./reactions";

export interface IActivityStore {
  historyMetadata: HistoryMetadataByChain;
  history: { data: TradeHistoryData | undefined; isLoading: boolean; error: Error | undefined };
}

export const INITIAL_STATE_ACTIVITY = {
  historyMetadata: {},
  history: { data: undefined, isLoading: false, error: undefined },
};

export const ActivityStore = new Store<IActivityStore>(INITIAL_STATE_ACTIVITY);

attachReactions();
